import React from 'react'
import { BiStar } from "react-icons/bi";

const TipsterAdvice = () => {
  return (
    <div className='tipster_container'>
      <div className="tipster_advice">
                    <h4>Tipster Advice</h4>
      
                    <div className="a_stars">
                      {[1, 2, 3, 4, 5].map((_, index) => (
                        <BiStar key={index} className="icon_star" />
                      ))}
                    </div>
      
                    <p>
                      To all clients, please minimize your betting habits. All tips
                      provided here are based purely on my personal intelligence,
                      experience, and instincts. Asakaaplay.com is strictly for
                      individuals aged 18 and above. BET RESPONSIBLY! Thank you.
                    </p>
      
                    <p
                      style={{
                        color: "white",
                      }}
                    >
                      @asakaaplay
                    </p>
                  </div>
    </div>
  )
}

export default TipsterAdvice
